/**
 *
 * 标准版本
 *
 */

import router from '@/router';
import { OPENMONITOR_URL } from '@/jmHttp/host';
import { storage } from '@/utils/storageOperateApi';
import { LOCAL_STORAGE_KEY } from '@/constants';
import { encrypt, customLink } from '@/utils/api';
import { getSummaryInfo } from '@/jmHttp/api/summary';
import { ElMessage } from 'element-plus';
import sensorsTrack from '@/common/sensorsTrack';
import store from '@/store';
import { isGeneralMode, BridgeBase } from './bridge_utils';
import i18n from '@/plugins/i18n';

const brmChannel = 'normal';

export const isThirdParty = isGeneralMode({ brmChannel });

if (isThirdParty) window.comeinChannel = brmChannel;

const getUserInfo = () => {
  const data = storage.get(LOCAL_STORAGE_KEY.JM_AUTH_INFO, true) || {};
  const { query } = router.currentRoute._value;
  const info = encodeURIComponent(
    encrypt(
      JSON.stringify({
        token: data.webtoken || data.webToken,
        go_id: data.outsideOrgId,
        uid: data.uid || data.comeinUid,
        uc: data.uc
      }),
      'A7#9K2$1jP!LzQ8W'
    )
  );
  return { info, data, query };
};

// 通用渠道Bridge类 - 使用默认实现，不需要重写方法
class Bridge extends BridgeBase {
  constructor() {
    super(brmChannel, false);
  }

  reLoginInfo() {
    return {
      confirmText: '确定',
      message: '用户未授权'
    };
  }

  reLogin() {
    router.push({ name: 'instituteNotFound' });
  }

  // 纪要详情页顶部查看回放按钮点击事件 调整合作路演页面
  goRoadshowPage(params) {
    store.dispatch('enterRoadshowLiveAction', {
      ...params,
      callback: (path) => {
        location.href = path;
      }
    });
  }

  // 纪要详情页顶部查看个股
  goStockDetail() {
    return {};
  }

  // 路演列表点击路演事件跳转路演厅事件
  goRoadshowDetail(params) {
    store.dispatch('enterRoadshowLiveAction', {
      ...params,
      callback: (path) => {
        location.href = path;
      }
    });
  }

  // 路演列表点击路演事件跳转ai智能纪要事件
  goAiSummaryDetail(params) {
    const { data } = getUserInfo();
    const lgoin = data.login && `JM${data.uid}`;
    window.location.href =
      OPENMONITOR_URL +
      `/meeting/summary_router?rid=${params.roadshowId}&uid=${data.uid}&token=${data.webtoken}&login=${lgoin}`;
  }

  // 个股详情页点击相关路演事件/纪要详情页 热门纪要、往期纪要
  goStockRoadshow(params) {
    const { id } = params;
    getSummaryInfo({
      roadshowId: id
    }).then(({ data }) => {
      const { aiSummary, meetSummary } = data;
      const { aiSummaryId, chatEnable, usePoints } = aiSummary || {};
      if (!meetSummary || !meetSummary.summaryId) {
        ElMessage.error(i18n.global.t('common.tip.meeting_no_summary'));
        return;
      }

      sensorsTrack.summaryTrack.clickSummaryTitle({
        sourceId: id,
        sourceUrl: '/summary/querySummaryPage'
      });

      const { query } = getUserInfo();
      const path = router.resolve({
        name: 'instituteSummaryDetail',
        query: {
          ...query,
          aiSummaryId,
          chatEnable,
          summaryId: meetSummary.summaryId,
          id,
          brmChannel: brmChannel,
          usePoints
        }
      });

      customLink(path.href);
    });
  }
}

// 导出实例作为默认导出（用于直接使用）
export default new Bridge();

// 同时导出类（用于 bridge.js 的原型链合并）
export { Bridge };
